import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import moment from 'moment'
import Cookies from "js-cookie";
Vue.use(Vuex);

const state = {
    //左侧会话列表
    sessions: [],
    //右侧 message列表
    messages: [],
    //左侧 会话ID
    conversationId: null,
    //左侧 当前点击的索引值
    currentSessionIndex:'',
    //左侧 额度数据
    quotaData:{
        usedFreeCount:0,
        freeTokenLimit:0,
        paidQuota:0,
        subscription:0,
        extra:0
    },
    // 是否刷新左侧列表
    isRefresh:true,
    requestId:'',
    //模型下拉列表
    models: [],
    //当前选中的模型
    selectedModel: '',
    //流数据调用API地址（根据模型变化）
    // streamApiPrefix:'http://192.168.1.15:8082/chat/stream',//测试
    streamApiPrefix:'/chat/stream',
    upload:'0',
    parentMessageId:'',
    url:'',
    urlList:[],
    img:'',
    isDark: true,
    networkMode: false,
    apiUrl: 'https://ark.cn-beijing.volces.com/api/v3/chat/completions',
    apiKey: 'ab78920a-e229-42b0-83f3-8e86e3ed2b06',
    allMessageList: [],
    isStreaming: false,
    streamingResponse: '',
    streamingConsider: '',
    considerCompleted: false,
};

const mutations = {
    SET_IS_REFRESH(state,isRefresh){
        state.isRefresh = isRefresh;
    },
    CREATE_NEW_SESSION(state) {
        const newSession = {
            conversationId: '',
            updatedAt: moment(Date.now()).format('yyyy-MM-DD HH:mm:ss'),
            title: `会话 ${state.sessions.length + 1}`,
            //是否置顶
            topFlag:'0'
        };
        state.sessions.push(newSession);
        state.conversationId = newSession.conversationId;
    },
    SET_MODELS(state,models){
        state.models = models;
    },
    SET_SELECTED_MODEL(state,seletedModel){
        state.selectedModel = seletedModel;
        if(state.selectedModel==='deepseek-r1-250120'){
            // state.streamApiPrefix = 'http://192.168.1.15:8082/chat/deepseekStream';
            state.streamApiPrefix = 'api/chat/deepseekStream';
        }else{
            // state.streamApiPrefix = 'http://192.168.1.15:8082/chat/stream';
            state.streamApiPrefix = 'api/chat/stream';
        }
    },
    SET_UPLOAD(state,upload){
      state.upload = upload;
    },
    SET_PARENT_MESSAGE_ID(state,parentMessageId){
        state.parentMessageId = parentMessageId;
    },
    SET_URL(state,url){
        state.url = url;
        if(state.url){
            state.urlList.push(url);
        }else{
            state.urlList = [];
        }

    },
    SET_SESSION(state, sessionList) {
        state.sessions = sessionList;
    },
    SET_MESSAGES(state, messageList){
        state.messages = messageList;
    },
    SELECT_SESSION(state, sessionId) {
        state.conversationId = sessionId;
    },
    SET_CURRENT_SESSION_INDEX(state,index){
        state.currentSessionIndex = index;
    },
    SET_REQUEST_ID(state,requestId){
        state.requestId = requestId;
    },
    // SET_HAS_DEEPTHINKING(state,hasDeepThinking){
    //     state.hasDeepThinking = hasDeepThinking;
    // },
    SET_IMG(state,img){
        state.img = img;
    },
    DELETE_SESSION(state, index) {
        state.sessions.splice(index,1);
    },
    SEND_MESSAGE(state, message) {
        state.messages.push({content: message, role: 'user'})
    },
    ADD_AI_RESPONSE(state, responseObj) {
        // 找到当前会话并添加 AI 回复到 该会话的消息列表
        state.messages.push({
            reasoningContent: responseObj.aiConsider || '',
            content: responseObj.aiResponse || '',
            role: 'assistant',
        })
    },
    CHANGE_MODEL(state, model) {
        state.selectedModel = model;
    },
    TOGGLE_THEME(state) {
        state.isDark = !state.isDark;
    },
    START_STREAMING(state) {
        state.isStreaming = true;
        state.streamingResponse = '';
        state.streamingConsider = '';
        state.considerCompleted = false;
    },
    UPDATE_STREAMING_CONSIDER(state, chunk, reset = false) {
        if (reset) {
            state.streamingConsider = chunk;
        } else {
            state.streamingConsider += chunk;
        }
    },
    COMPLETE_CONSIDER(state) {
        state.considerCompleted = true;
    },
    UPDATE_STREAMING_RESPONSE(state, chunk, reset = false) {
        //console.log(state.streamingResponse)
        if (reset) {
            state.streamingResponse = chunk;
        } else {
            state.streamingResponse += chunk;
        }
    },
    END_STREAMING(state) {
        state.isStreaming = false;
        
        // 不在此处添加消息，因为UI组件已经负责在视图上显示流式内容
        // 保留注释以说明为什么移除此逻辑
        // if (state.streamingResponse || state.streamingConsider) {
        //     state.messages.push({
        //         reasoningContent: state.streamingConsider,
        //         content: state.streamingResponse,
        //         role: 'assistant'
        //     });
        // }
        // 完全移除添加消息的逻辑，这应该由UI组件处理
        // 消息已经在UI组件中通过流式更新显示
    },
    SET_NETWORK_MODE(state, status) {
        state.networkMode = status;
    },
    SET_QUOTA_DATA(state, quotaData) {
        state.quotaData = quotaData;
    },
};

const actions = {
    createNewSession({commit}) {
        commit('CREATE_NEW_SESSION');
    },
    selectSession({commit}, sessionId) {
        commit('SELECT_SESSION', sessionId);
    },
    deleteSession({commit}, index) {
        commit('DELETE_SESSION', index);
    },
    async sendMessage({commit, state}, message) {
		console.log("TCL: sendMessage -> 发送消息sendMessagechat")
		// console.log("TCL: sendMessage -> state", state)
        const messageContent = typeof message === 'object' ? message.message : message;
        const useStream = typeof message === 'object' ? (message.useStream !== false) : true;
        
        return new Promise((resolve, reject) => {
            if(state.upload=='0'){
                if ((!messageContent || typeof messageContent !== 'string')) {
                    return reject(new Error('消息内容不能为空'));
                }
            }


            
            // 发送用户消息
            //commit('SEND_MESSAGE', messageContent);
			// console.log("TCL: sendMessage -> 走这里")
            if (useStream) {
                // 使用 EventSource 进行流式处理
                // console.log("TCL: sendMessage -> 使用 EventSource 进行流式处理")
                // const encodedMessage = encodeURIComponent(messageContent);
                // console.log(encodedMessage)

                // 构建URL，包含会话ID（如果有）
                // let eventSourceUrl = `http://192.168.1.15:8082/chat/stream?content=${encodedMessage}&user_id=${ JSON.parse(Cookies.get("userInfo")).id}`;
                // 构建请求体，按照后端定义的OpenAIChatRequest格式
                const requestBody = {
                    content: messageContent,
                    user_id: JSON.parse(Cookies.get("userInfo")).id,
                    model: state.selectedModel,
                    network: state.networkMode ? "1" : "0",
                    upload: state.upload
                };

                // 添加条件参数
                if (state.upload == '1' && state.urlList.length > 0) {
                    requestBody.url = state.urlList;
                }
                
                if (state.conversationId) {
                    requestBody.conversation_id = state.conversationId;
                }

                if (state.parentMessageId) {
                    requestBody.parent_message_id = state.parentMessageId;
                }
                
                commit('START_STREAMING'); // 启动流式状态
                
                // 事件处理函数定义（使用函数表达式而非函数声明）
                const handleRequestIdEvent = (event) => {
                    if (event.data !== undefined) {
                        commit('SET_REQUEST_ID', event.data);
                    }
                };
                
                const handleImgEvent = (event) => {
                    console.log("TCL: sendMessage -> 接收图片");
                    let imgUrl = event.data;
                    if (imgUrl !== undefined) {
                        if (imgUrl[imgUrl.length-1] == ')') {
                            imgUrl = imgUrl.substring(0, imgUrl.length-1);
                        }
                        commit('SET_IMG', imgUrl);
                    }
                    console.log("TCL: sendMessage ->imgUrl1 ", imgUrl);
                };
                
                const handleContentEvent = (event) => {
                    console.log("TCL: content -> 接收内容");
                    if (event.data !== undefined) {
                        let contentData = event.data;
                        if (!state.selectedModel.includes('gpt-4o-image-vip')) {
                            commit('UPDATE_STREAMING_RESPONSE', contentData);
                        }
                    } else {
                        let contentData = event.data;
                        commit('UPDATE_STREAMING_RESPONSE', contentData);
                    }
                };
                const handleIsRefreshEvent = (event,eventType) => {
                    if (event.data !== undefined&&eventType=='error') {
                        let contentData = event.data;
                        commit('SET_IS_REFRESH', false);
                        commit('UPDATE_STREAMING_RESPONSE', contentData);
                    }else{
                        commit('SET_IS_REFRESH', true);
                    }
                };
                
                const handleReasoningContentEvent = (event) => {
                    if (event.data !== undefined) {
                        commit('UPDATE_STREAMING_CONSIDER', event.data);
                    }
                };
                
                const handleCompleteEvent = (event) => {
                    try {
                        if (event.data) {
                            const data = JSON.parse(event.data);
                            if (data.conversation_id) {
                                commit('SELECT_SESSION', data.conversation_id);
                            }
                        }
                    } catch (e) {
                        console.warn('解析完成事件数据失败:', e);
                    }
                    
                    commit('END_STREAMING');
                    resolve({
                        aiConsider: state.streamingConsider,
                        aiResponse: state.streamingResponse
                    });
                };
                
                const processEventData = (data) => {
                    // 分割多个事件
                    const events = data.split('\n\n').filter(e => e.trim());
                    
                    events.forEach(eventText => {
                        const eventLines = eventText.split('\n');
                        let eventType = '';
                        let eventData = '';
                        
                        // 解析事件类型和数据
                        eventLines.forEach(line => {
                            if (line.startsWith('event:')) {
                                eventType = line.substring(6).trim();
                            } else if (line.startsWith('data:')) {
                                eventData = line.substring(5).trim();
                            }
                        });
                        
                        // 如果有事件类型和数据，处理事件
                        if (eventType && eventData) {
                            const event = { data: eventData };
                            
                            switch (eventType) {
                                case 'request_id':
                                    handleRequestIdEvent(event);
                                    handleIsRefreshEvent(event,eventType);
                                    break;
                                case 'img':
                                    handleImgEvent(event);
                                    handleIsRefreshEvent(event,eventType);
                                    break;
                                case 'content':
                                    handleContentEvent(event);
                                    handleIsRefreshEvent(event,eventType);
                                    break;
                                case 'reasoningContent':
                                    handleReasoningContentEvent(event);
                                    handleIsRefreshEvent(event,eventType);
                                    break;
                                case 'complete':
                                    handleCompleteEvent(event);
                                    handleIsRefreshEvent(event,eventType);
                                    break;
                                default:
                                    console.log('未知事件类型:', eventType, eventData);
                                    handleIsRefreshEvent(event,eventType);
                                    break;
                            }
                        }
                    });
                };
                
                // 使用fetch API发送POST请求并处理流式响应
                fetch(state.streamApiPrefix, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'text/event-stream'
                    },
                    body: JSON.stringify(requestBody)
                }).then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    
                    // 获取响应流的读取器
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();
                    let buffer = '';
                    
                    // 处理数据流
                    const processStream = () => {
                        return reader.read().then(({ done, value }) => {
                            if (done) {
                                // 处理完成
                                if (buffer.length > 0) {
                                    processEventData(buffer);
                                }
                                
                                // 完成流式处理
                                const completeEvent = { data: JSON.stringify({ conversation_id: state.conversationId }) };
                                handleCompleteEvent(completeEvent);
                                return;
                            }
                            
                            // 解码数据并添加到缓冲区
                            const text = decoder.decode(value, { stream: true });
                            buffer += text;
                            
                            // 处理缓冲区中的完整事件
                            const eventEndIndex = buffer.lastIndexOf('\n\n');
                            if (eventEndIndex > -1) {
                                const eventData = buffer.substring(0, eventEndIndex);
                                buffer = buffer.substring(eventEndIndex + 2);
                                
                                // 处理事件数据
                                processEventData(eventData);
                            }
                            
                            // 继续处理流
                            return processStream();
                        });
                    };
                    
                    // 开始处理流
                    return processStream();
                }).catch(error => {
                    console.error('Fetch错误:', error);
                    commit('END_STREAMING');
                    state.url = [];
                    state.upload = '0';
                    reject(error);
                });
            } else {
                console.log("TCL: sendMessage -> 使用普通 POST 请求")
                // 使用普通 POST 请求
                const apiUrl = `/chat/aa`;
                
                const headers = {
                    'Content-Type': 'application/json'
                };
                
                // 构建请求体，包含会话ID（如果有）
                const requestBody = {
                    content: messageContent
                };
                
                if (state.conversationId) {
                    requestBody.conversation_id = state.conversationId;
                }
                
                axios.post(apiUrl, requestBody, { 
                    headers,
                    withCredentials: true
                })
                .then((res) => {
                    // 如果响应中包含会话ID，保存它
                    if (res.data.conversation_id) {
                        commit('SELECT_SESSION', res.data.conversation_id);
                    }
                    
                    commit('ADD_AI_RESPONSE', {
                        aiConsider: res.data.message?.reasoning_content || '',
                        aiResponse: res.data.message?.content || res.data.content || ''
                    });
                    
                    resolve({
                        aiConsider: res.data.message?.reasoning_content || '',
                        aiResponse: res.data.message?.content || res.data.content || ''
                    });
                })
                .catch(error => {
                    console.error('获取AI回复时出错:', error.response || error);
                    reject(error);
                });
            }
        });
    },

    changeModel({commit}, model) {
        commit('CHANGE_MODEL', model);
    },
    toggleTheme({commit}) {
        commit('TOGGLE_THEME');
    }
};

const getters = {
    currentMessages(state) {
        return state.messages;
        // const currentSession = state.sessions.find(session => session.conversationId === state.conversationId);
        // return currentSession ? currentSession.messages : [];
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
